import { Hit, InfiniteHitsProvided } from 'react-instantsearch-core';
import { SearchAction, SearchObject, TagAction } from './Models';
import { P2GAlert, P2GButton, P2GGrid, P2GText } from '@parcel2go/core-ui';

export interface IHitProps {
  hit: Hit<SearchObject>;
  searchActions?: SearchAction;
  additionalTags?: TagAction;
}

export interface IHitsProps extends InfiniteHitsProvided<Hit<SearchObject>> {
  refineNext: () => void;
  hasMore: any;
  refinePrevious: () => void;
  hasPrevious: any;
  hits: any;
  hit?: SearchAction;
  hideFilter?: boolean;
}

const Hits: React.FC<IHitsProps> = (props) => {
  if (props.hits.length === 0) {
    return (
      <P2GAlert color="info">
        <P2GText>No Results...</P2GText>
      </P2GAlert>
    );
  }

  return (
    <P2GGrid container spacing={2} direction="column">
      {!props.hideFilter && props.hasPrevious && (
        <P2GGrid item xs={12}>
          <P2GButton onClick={props.refinePrevious} fullWidth>
            Load Previous
          </P2GButton>
        </P2GGrid>
      )}
      <P2GGrid item xs={12}>
        <P2GGrid container spacing={2} direction="column">
          {props.hits.map((hit) => (
            <P2GGrid item key={hit.orderLineId}>
              {props.hit(hit)}
            </P2GGrid>
          ))}
        </P2GGrid>
      </P2GGrid>
      {!props.hideFilter && props.hasMore && (
        <P2GGrid item xs={12}>
          <P2GButton onClick={props.refineNext} fullWidth>
            Load More
          </P2GButton>
        </P2GGrid>
      )}
    </P2GGrid>
  );
};

export default Hits;
